import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-chevron',
  imports: [],
  templateUrl: './icon-chevron.component.html',
  styleUrl: './icon-chevron.component.css',
})
export class IconChevronComponent {

}
